<template>
  <el-dialog
    append-to-body
    width="600px"
    :title="info.replenish_desc?'查看描述':'补充描述'"
    center
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-position="left"
      label-width="80px"
      :model="form.data"
      :rules="form.rules"
    >
      <el-form-item prop="replenish_desc" label="描述">
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入"
          v-model="form.data.replenish_desc"
          clearable
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="images" label="上传图片">
        <el-upload
          action=""
          list-type="picture-card"
          multiple
          :headers="{ token: token }"
          :file-list="form.data.images"
          :before-upload="beforeAvatarUpload"
          :http-request="httpRequest"
          :on-exceed="handleExceed"
          :limit="9"
          :on-remove="handleRemove"
          :on-preview="handlePictureCardPreview"
          accept="image/*">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >保存</el-button
        >
      </el-row>
    </template>
    <!-- 图片预览弹窗：append-to-body 让 DOM 挂到 body 下，避免被外层弹窗遮罩盖住 -->
    <el-dialog append-to-body :visible.sync="dialogVisible">
      <img  :src="dialogImageUrl" alt="" />
    </el-dialog>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      token: "",
      visible: false,
      loading: false,
      info: {},
      form: {
        loading: false,
        data: {
          replenish_desc: "",
          images: [],
        },
        rules: {
          // replenish_desc: [
          //   { required: true, message: "必填", trigger: "change" },
          // ],
        },
      },
      dialogImageUrl: '',
      dialogVisible: false
    };
  },
  methods: {
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 获取详情
    getDetail(row) {
      this.info = row;
      this.form.data = { replenish_desc: row.replenish_desc || "", images: [] };
      this.form.data.images = row.image.map(v => ({ name: Date.now(), url: v }));
    },
    reset(done) {
      this.form.data = { replenish_desc: "", images: [] };
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    confirm() {
      console.log(this.form.data)
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          let _param = {
            id: this.info.id,
            replenish_desc: this.form.data.replenish_desc,
            image: this.form.data.images.map(v => v.url).join("|"),
          };
          let apiUrl = "/admin/flex_job/descReplenish";
          this.$http
            .post(apiUrl, _param)
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("保存成功");
                this.toggle(false);
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 50;
      if (!isLt5M) {
        this.$message.error("上传文件大小不能超过 50MB!");
      }
      return isLt5M;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前最多选择9个文件`);
    },
    httpRequest(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      this.$http
        .post("/common/qiniu/uploadFile", { formData, type: "upload" })
        .then((res) => {
          this.form.data.images.push({ name: Date.now(), url: res.data.all_path_url });
        });
    },
    handleRemove(file, fileList) {
      this.form.data.images = fileList;
    },
  },
};
</script>
